import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getCurrentUser } from "../selectors/userSelectors";
import { identifyPostHog } from "../utils/posthog";

// Identifies the logged-in student in PostHog. Mounted inside the
// authenticated LMS shell, so it only runs for logged-in users. Re-runs when
// the current user changes; identifyPostHog itself is idempotent per user.
export default function usePostHogIntegration() {
  const currentUser = useSelector(getCurrentUser);
  const userId = currentUser?.id;

  useEffect(() => {
    if (!userId) return;

    identifyPostHog(currentUser);
  }, [userId]);
}
